module.exports = __webpack_public_path__ + "media/images/360/narcolepsy_moon_mountains-26b38915cba106dbd71e22b6859b388a.webp";